import request from '@/utils/request'

// 新增业务在线申请管理
export function addQybztgsq(data) {
  return request({
    url: '/web/zlts/bzfw/qybztgsq',
    method: 'post',
    data: data
  })
}
